<script>
import { HeartIcon, CurrencyDollarIcon, EnvelopeIcon } from '@heroicons/vue/24/outline'
import TwCard from '@/components/generic/tw-card.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwProgressBar from '@/components/generic/tw-progress-bar.vue'
import FundraiserSubscribeToUpdatesModal from '@/components/fundraiser-updates/fundraiser-subscribe-to-updates-modal.vue'
import TwTimeLeft from '@/components/generic/tw-time-left.vue'
import DonationsListGroup from '@/components/donations/public/donations-list-group.vue'
import FundraiserPageRaisedAmount from '@/components/fundraiser-pages/public/fundraiser-page-raised-amount.vue'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import FundraiserPageSocialsShare from '@/components/fundraiser-pages/fundraiser-page-socials-share.vue'
export default {
  name: 'FundraiserPageRightColumn',
  components: { FundraiserPageSocialsShare, TwModal, FundraiserPageRaisedAmount, DonationsListGroup, TwTimeLeft, FundraiserSubscribeToUpdatesModal, TwProgressBar, TwButton, TwCard, HeartIcon, CurrencyDollarIcon, EnvelopeIcon },
  props: {
    fundraiserPage: {
      type: Object,
      required: true
    }
  },
}
</script>

<template>
  <div class="">
    <div class="lg:hidden flex flex-col items-center">
      <img v-if="fundraiserPage.cached.owner_avatar_url_small" class="h-32 w-32 rounded-full object-cover border-2" :src="fundraiserPage.cached.owner_avatar_url_small" :alt="fundraiserPage.cached.owner_name">
      <span v-else class="inline-flex h-32 w-32 items-center justify-center rounded-full bg-gray-200">
        <span v-if="fundraiserPage.cached.owner_initials" class="text-3xl font-sans leading-none text-gray-400">{{ fundraiserPage.cached.owner_initials }} </span>
      </span>
    </div>
    <div class="lg:rounded-lg lg:shadow-sm lg:bg-white p-0 lg:p-6">
      <div v-if="fundraiserPage.cached">
        <fundraiser-page-raised-amount :fundraiser-page="fundraiserPage" />
        <tw-progress-bar :progress="fundraiserPage.cached.percentage_raised" />
        <tw-time-left v-if="fundraiserPage.deadline" class="mb-5 text-gray-600 text-sm" :deadline="fundraiserPage.deadline" detailed />
        <tw-button :to="{name: 'FundraiserPageDonatePage', params:{ fundraiserPageId: fundraiserPage.id }}" block size="lg" class="w-full" variant="primary">
          Donate
        </tw-button>
        <div class="flex gap-3 mt-3">
          <tw-button block variant="secondary" class="text-md" @click="$refs.shareModal.open()">
            Share
          </tw-button>
          <tw-button block variant="secondary" class="text-md" @click="$refs.subscribeToFundraiserModal.open()">
            Subscribe
          </tw-button>
        </div>
      </div>
      <donations-list-group class="mt-10 hidden lg:block" :fundraiser-page="fundraiserPage" />
      <div class="hidden lg:static">
        <div class="uppercase mb-8">
          <heart-icon class="h-4 inline" /> Organizer: {{ fundraiserPage.cached.organizer_name }}
        </div>
        <div class="uppercase">
          <currency-dollar-icon class="h-4 inline" /> Beneficiary: {{ fundraiserPage.cached.beneficiary_name }}
        </div>
      </div>
      <fundraiser-subscribe-to-updates-modal ref="subscribeToFundraiserModal" :subscribable="fundraiserPage" />
      <tw-modal ref="shareModal" ok-only ok-text="Close" variant="secondary" title="Share this fundraiser" @ok="$refs.shareModal.close()">
        <fundraiser-page-socials-share :fundraiser-page="fundraiserPage" />
      </tw-modal>
    </div>
  </div>
</template>

<style scoped>

</style>
